import { tool } from 'ai';
import { z } from 'zod';

import { ToolCreator } from 'mode-shared/types/tools';

/**
 * Gets the current locale date/time string.
 */
const createCurrentDateTimeTool: ToolCreator = () => {
  return tool({
    description: 'Returns the current date, time, or both based on user input',
    execute: ({ type }) => {
      const now = new Date();
      let result: string;

      switch (type) {
        case 'date':
          result = now.toLocaleDateString();
          break;
        case 'time':
          result = now.toLocaleTimeString();
          break;
        case 'datetime':
        default:
          result = now.toLocaleString();
          break;
      }

      return Promise.resolve({ result });
    },
    parameters: z.object({
      type: z.enum(['date', 'datetime', 'time']).describe('Type of date/time to return. Defaults to "datetime".'),
    }),
  });
};

export default createCurrentDateTimeTool;
